import {
  AddressData,
  PonyfillFactoryCredentials,
  RetorikThemeColors,
  UserData,
} from '@davi-ai/retorik-framework'

const tenants: { [key: string]: AddressData } = {
  MVEB: {
    tenant: 'slw6dfylrjfsfbkm4n'
  }
}

const userData: UserData = {
  name: '',
  id: Math.random().toString(36).substring(2, 9),
  username: '',
  nom: '',
  prenom: '',
  email: '',
  token: '',
  referrer: '',
  ipaddress: ''
}

const ponyfillFactoryCredentials: PonyfillFactoryCredentials = {
  region: 'francecentral',
  subscriptionKey: '2f62867e22a544b78a16c99a2707ef49'
}

const voices = {
  guy: {
    voice: 'GuyNeural'
  },
  henri: {
    voice: 'HenriNeural'
  },
  multiMale:{
    voice:"en-US-RyanMultilingualNeural"
  },
  multi: {
    voice: 'JennyMultilingualNeural'
  }
}

const colorOnLight = "#323c46";
const colorOnDark = "#f07026";
const commonColors = {
  primary: '#f07026',
  secondary: colorOnLight,
  black: '#323c46',
  whereToEatColor: '#FC952E',
  whereToSleepColor: '#9F007D',
  tobeSeenColor: '#76AB2A',
  tobeDoneColor: '#E23C2A',
  localProductsColor: '#AFB942',
  servicesColor: '#00C8BC',
  agendaColor: '#865DA2'
}

const colors : RetorikThemeColors = {
  ...commonColors,
  theme:"dark",
  companyName: '#000',
  loader: {
    animation: colorOnDark,
    background: 'rgba(18,18,18,0.7)',
    text: '#FFF',
    toggle: {
      text: '#000',
      background: colorOnDark
    },
    button: {
      background: {
        default: 'transparent',
        hover: 'transparent'
      },
      border: {
        default: colorOnDark,
        hover: '#FFF'
      },
      text: {
        default: colorOnDark,
        hover: '#FFF'
      }
    }
  },
  card: {
    frame: {
      background: colorOnLight,
      border: 'transparent',
      text: '#F7F3F6'
    },
    button: {
      background: {
        default: 'transparent',
        hover: 'transparent'
      },
      border: {
        default: colorOnDark,
        hover: '#FFF'
      },
      text: {
        default: colorOnDark,
        hover: '#FFF'
      }
    }
  },
  textMode: {
    panel: {
      background: 'rgba(255, 255, 255, 0.9)',
      border: 'transparent',
      conversationUser: '#101219',
      conversationBot: commonColors.primary
    }
  },
  vocalMode: {
    subtitles: {
      text: '#FFF',
      background: '#000'
    }
  },
  formInput: {
    text: {
      default: colorOnLight,
      hover: '#FFF'
    },
    inputRadioCheckbox: {
      unchecked: {
        background: '#434141',
        border: '#818181'
      },
      checked: {
        background: commonColors.primary,
        border: commonColors.primary,
        item: '#000'
      }
    },
    inputButton: {
      background: {
        default: commonColors.black,
        hover: commonColors.primary
      },
      border: {
        default: commonColors.primary,
        hover: '#FFF'
      },
      text: {
        default: '#FFF',
        hover: '#FFF'
      }
    },
    likert: {
      default: 'transparent',
      hover: '#E8B712'
    }
  }
}

export {
  tenants,
  userData,
  ponyfillFactoryCredentials,
  voices,
  colors
}
